<template>
  <div class="bg-white">
    <!--轮播图-->
    <scroll-carousel :homeScroll="indexData.homeScroll"/>
    <!--页面主体内容-->
    <!--页面内容-->
    <div  class="bg-base" style="min-width: 1200px" v-if="false">
      <div class="wrap-style" >
        <div class="feature-wrap" v-for="(item,index) in slogan" :key="index">
          <p class="h2">{{item.title}}</p>
          <p v-html="item.content"></p>
        </div>
      </div>
    </div>
     <div class="base-wrap mt-4">
       <!--酒店轮播-->
       <recommend-hotel-swiper :homeScroll="indexData.homeScrollHotel"/>
       <!--推荐酒店-->
       <recommend-hotel :homeScrollHotel="indexData.homeScrollHotel" :homeHotelOther="indexData.homeHotelOther" class="mt-4" />
       <!--推荐民宿-->
       <!-- <recommend-homestay :homeStay="indexData.homeStay" type="homestay"/> -->
       <!--推荐景区-->
       <!-- <recommend-homestay :homeStay="indexData.viewpoint" type="scenic"/> -->
       <!--合作品牌-->
       <!-- <cooperate-brand :brandCooperate="indexData.homeHotelCooperate" /> -->
       <!--底部咨询-->
       <!-- <ul class="fourItemsList">
          <li>1234</li>
       </ul> -->
     </div>
  </div>
</template>

<script>
  import {mapActions, mapState, mapGetters} from 'vuex'
  import ScrollCarousel from './../IndexComps/IndexPage/ScrollCarousel'
  import RecommendHotel from './../IndexComps/IndexPage/RecommendHotel2'
  import RecommendHomestay from './../IndexComps/IndexPage/RecommendHomestay'
  import CooperateBrand from './../IndexComps/IndexPage/CooperateBrand'
  import RecommendHotelSwiper from '../IndexComps/IndexPage/RecommendHotelSwiper.vue'
  export default {
    name: 'PageWrap',
    components: {ScrollCarousel,RecommendHotel,RecommendHomestay,CooperateBrand,RecommendHotelSwiper},
    data() {
      return {
        indexData: {},
        slogan:[
          {title:'安全保障',content:'100%真实房源，全程安全保障'},
          {title:'价格优惠',content:`全网比价，保证最低价`},
          {title:'专属客服',content:`全天候专属客服，随时解答`},
          {title:'品质认证',content:`严选品质酒店，放心入住`},
        ]
      }
    },
    created() {
      this.getIndexInfo();
    },
    mounted() {
      this.afterWxLoginBack();
    },
    methods: {
      ...mapActions(['UserLogin']),
      /*获取首页数据*/
      async getIndexInfo() {
        let res = await this.$axios.post('/pc/Home/Index', {needType:1});
        if (res.code === '00000') this.indexData = res.data;
      },
      afterWxLoginBack() {
        var tValue = this.$route.query.t || ''; 
        if(!tValue){
            return
        }
        // 执行解码 
        const { success, data, error } = this.decodeBase64Url(tValue);
        if (success) {
          tValue= data;
          this.UserLogin({type: 'user',res:tValue})
        } 
      },
      // 解码你这个特殊的 base64 字符串
      decodeBase64Url(str) {
        // 第一步：把 URL 安全字符 还原回标准 base64
        str = str.replace(/-/g, '+').replace(/_/g, '/').replace(/~/g, '=');
        // 补全等号（必须）
        while (str.length % 4) {
          str += '=';
        }
        try {
          // 解码
          const decodeStr = decodeURIComponent(escape(atob(str)));
          return { success: true, data: JSON.parse(decodeStr) }; // 直接转对象
        } catch (e) {
          return { success: false, error: err };;
        }
      },
    }
  }
</script>

<style lang="scss" scope>
  .wrap-style{
    padding: 30px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1200px;
    margin: auto;
    .feature-wrap{
      width: 280px;
      height: 100px;
      display: flex;
      align-items: center;
      background: #fff;
      p:nth-child(1){
        width: 30%;
        font-weight: bolder;
      }
      p:nth-child(2){
        width: 70%;
        color: #919191;
        text-align: left;
      }
    }
  }

</style>
